
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getToken } from '../../reducers/auth';
import {
    getProject,
    getProjectKatuzeItems
} from '../../reducers/project';
import { getAnalyze, getDefault, getOpsubNew, getOpsubOld } from '../../reducers/analyze2opsub';
import { getAnalyzeData } from '../../reducers/analyze2opsub/analyze';
import { getIsknDateNew, getIsknDateOld, getOpsubItemNew, getOpsubItemOld } from '../../reducers/analyze2opsub/reducer';
import { getOpsubItems } from '../../reducers/common/opsub';
import analyze2opsubGetActions from '../../sagas/analyze2opsub';

import Analyze2OpsubView from './Analyze2Opsub.view';

const Analyze2OpsubState = () => {

    const dispatch = useDispatch();
    const analyze2opsubActions = analyze2opsubGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));

    const project = useSelector(state => getProject(state.project));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));
    const projectKatuzeKod = projectKatuzeItems.map(item => item.kod);

    const opsubItemsNew = useSelector(state => getOpsubItems(getOpsubNew(state.analyze2opsub)));
    const opsubItemsOld = useSelector(state => getOpsubItems(getOpsubOld(state.analyze2opsub)));
    const analyzeData = useSelector(state => getAnalyzeData(getAnalyze(state.analyze2opsub)));
    const analyze = useSelector(state => getAnalyze(state.analyze2opsub));

    const isknDateNew = useSelector(state => getIsknDateNew(getDefault(state.analyze2opsub)));
    const isknDateOld = useSelector(state => getIsknDateOld(getDefault(state.analyze2opsub)));
    const opsubItemNew = useSelector(state => getOpsubItemNew(getDefault(state.analyze2opsub)));
    const opsubItemOld = useSelector(state => getOpsubItemOld(getDefault(state.analyze2opsub)));

    const iskn = useSelector(state => state.iskn);

    const canAnalyze = isknDateNew && isknDateOld && opsubItemNew && opsubItemOld;

    const handleClickAnalyze = () => {
        if (canAnalyze) {
            const isknDates = iskn.data.map(item => item.date);
            const start = isknDates.indexOf(isknDateOld);
            const end = isknDates.indexOf(isknDateNew);
            const isknDatesForAnalyze = isknDates.slice(start, end + 1);

            analyze2opsubActions.analyze2Opsub(
                token, project.id, projectKatuzeKod,
                isknDatesForAnalyze, opsubItemOld.id, opsubItemNew.id
            );
        }
    }

    const handleChangeNew = (isknDate, opsubItem) => {
        analyze2opsubActions.setIsknDateNew(isknDate);
        analyze2opsubActions.setOpsubItemNew(opsubItem);
    }

    const handleChangeOld = (isknDate, opsubItem) => {
        analyze2opsubActions.setIsknDateOld(isknDate);
        analyze2opsubActions.setOpsubItemOld(opsubItem);
    }

    return (
        <Analyze2OpsubView
            analyzeData={analyzeData}
            analyze2opsubActions={analyze2opsubActions}
            canAnalyze={canAnalyze}
            isAnalyzeLoading={analyze.loading}
            isAnalyzeLoaded={analyze.loaded}
            isknDateNew={isknDateNew}
            isknDateOld={isknDateOld}
            project={project}
            opsubItemNew={opsubItemNew}
            opsubItemOld={opsubItemOld}
            opsubItemsNew={opsubItemsNew}
            opsubItemsOld={opsubItemsOld}
            projectKatuzeKod={projectKatuzeKod}
            token={token}
            onClickAnalyze={handleClickAnalyze}
            onChangeNew={handleChangeNew}
            onChangeOld={handleChangeOld}
        />
    )
}

export default Analyze2OpsubState;
